import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { MapPin } from "lucide-react";
export default function PatioDoorRepairServicesInChateauguay() {
  return <section data-section-id="252584" id="the-elite-standard" className="relative bg-[#F8F5E9] overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673628/img/elite_landscaping_patio_design.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673628/img/elite_landscaping_patio_design.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673628/img/elite_landscaping_patio_design.png-wvc-sizes" alt="Pristine architectural patio design" className="w-full h-full object-cover opacity-100 transition-transform duration-700 hover:scale-105" style={{
        clipPath: "polygon(60% 0, 100% 0, 100% 100%, 40% 100%)"
      }} loading="lazy" decoding="async" />
      </div>

      {}
      <div className="page-container relative z-10 py-24 md:py-32 lg:py-40 flex flex-col items-start text-left">
        <h1 className="font-default text-4xl md:text-5xl lg:text-[84px] font-black text-[#2C2C2C] leading-tight mb-6 max-w-4xl tracking-tighter uppercase">
          HARD WORKING <span className="text-[#8DC63F]">YOUNG MEN</span> LANDSCAPING
        </h1>
        
        <p className="font-default text-lg md:text-[24px] text-[#4A4A4A] mb-4 max-w-2xl leading-relaxed font-semibold flex items-center">
          <span className="inline-block w-12 h-[2px] bg-[#F2C94C] mr-4"></span>
          WE WORK HARD. YOU ENJOY MORE.
        </p>

        <h2 className="flex items-center gap-2 text-[#4A4A4A]/70 font-default text-sm md:text-base font-medium mb-10 uppercase tracking-widest">
          <MapPin className="size-4 text-[#8DC63F]" />
          Serving Akron, Canton, Cleveland & Surrounding Areas
        </h2>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <Link to="/HomePage">
            <Button size="lg" className="bg-[#1A412A] hover:bg-[#1A412A]/90 text-white font-bold text-lg h-14 px-8 rounded-lg shadow-lg shadow-[#1A412A]/20 transition-transform hover:scale-105 uppercase tracking-wider">
               Request a Free Estimate
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}